import { useUser } from '@cast/infrastructure-auth';
import { useFlagsQuery } from '@cast/infrastructure-abilities';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useIsOpsPilotFeatureFlagEnabled = (): boolean => {
  const { currentOrganization } = useOrganizations();
  const user = useUser();

  const { data: featureFlags } = useFlagsQuery({
    flagName: 'ui__standalone--cost-report-ai-assistant',
    targetingKey: currentOrganization?.id,
    enabled: !!user && !!currentOrganization,
  });

  return featureFlags?.some((flag) => flag.boolean) ?? false;
};
